<template>
  <Select
    :model-value="inputValue"
    :type="type"
    :hint="errorMessage"
    :empty-value-to="emptyValueTo"
    :is-error="!!errorMessage"
    @update:model-value="setValue"
  />
</template>

<script setup lang="ts">
import type { FuelType } from '@/entities/cars/fuel-type.enum';
import { useField } from 'vee-validate';
import { toRef, watch } from 'vue';
import Select from './Select.vue';

const props = defineProps<{
  name: string;
  inputValue?: FuelType | null;
  initialValue?: string | number | null | undefined;
  emptyValueTo?: 'null' | 'undefined';
  type?: 'text' | 'number';
  keepValueOnUnmount?: boolean;
}>();

const emits = defineEmits(['update:inputValue']);

const name = toRef(props, 'name');

const {
  value: inputValue,
  setValue,
  errorMessage,
} = useField<string | number | null | undefined>(name, undefined, {
  initialValue: props.initialValue,
  keepValueOnUnmount: props.keepValueOnUnmount,
});

watch(inputValue, (inputUpdate) => {
  emits('update:inputValue', inputUpdate);
});
</script>
